<template>
    <v-container fluid pa-0 dark flat my-5>
        <v-layout row wrap>
            <v-flex xs10 sm6 offset-xs4>
                <h2 >Seguimiento</h2>
                <v-flex xs12 sm6 md6>
                    <v-text-field label="Numero de Servicio(N.S)" v-model="ns"></v-text-field>
                    <v-btn color="primary" dark @click="searchService('Seguimiento_InicioBusqueda')">Buscar Servicio</v-btn>
                    <br>
                </v-flex>
                <br>
            </v-flex>
        </v-layout>
        <div v-if="pedido.existe">
            <v-layout  row wrap>
                <v-flex xs10 sm6 offset-xs3>
                    <v-stepper v-model="pasos">
                        <v-stepper-header>
                            <v-stepper-step v-if="pasos == 1" :complete="pasos == 1" step="1" complete-icon="fas fa-truck subheading">En Ruta al Origen</v-stepper-step>
                            <v-stepper-step v-else-if="pasos >= 1" :complete="pasos >= 1" step="1" complete-icon="fas fa-check subheading">En Ruta al Origen</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step v-if="pasos == 2" :complete="pasos == 2" step="2" complete-icon="fas fa-truck subheading">En ruta al Destino</v-stepper-step>
                            <v-stepper-step v-else-if="pasos >= 2" :complete="pasos >= 2" step="2" complete-icon="fas fa-check subheading">En ruta al Destino</v-stepper-step>
                            <v-stepper-step v-else-if="pasos == 1" :complete="pasos == 2" step="2" complete-icon="fas fa-truck subheading">En ruta al Destino</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="pasos >= 3" step="3" complete-icon="fas fa-truck subheading">Servicio finalizado</v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                </v-flex>
            </v-layout>
            <br>
            <v-layout row wrap>
                <v-flex v-if="pedido.progreso && pedido.progreso.length > 0" xs10 sm3 offset-xs1>
                    <h3>Progreso Servicio: </h3>
                        <div
                            v-for="(el, index) in pedido.progreso"
                            :key="index"
                            style="
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                border-bottom: 1px solid #cacaca;
                                margin-bottom: 3px;
                                ">
                            <p>{{ el.estado }}</p>
                            <p>{{ el.date.toDate() | dateFromTimestamp }}</p>
                        </div>
                </v-flex>
                <v-flex v-else>
                    <h3>No hay progreso registrado</h3>
                </v-flex>
                <v-flex v-if="pedido.transportista" xs10 sm3 offset-xs2> 
                    <h3 align-center> Conductor y Vehículo:</h3>
                    <br>
                    <p>Nombre Conductor: {{ pedido.transportista.conductor_data.datos.nombres + ' ' + pedido.transportista.conductor_data.datos.apellidos }}</p>
                    <p>R.U.T: {{ pedido.transportista.conductor_data.datos.rut }}</p>
                    <p>Patente: {{ pedido.transportista.datos.patente }}</p>
                    <p>Marca: {{ pedido.transportista.datos.marca }}</p>
                    <p>Modelo: {{ pedido.transportista.datos.modelo }} </p>
                    <p>Tipo carrocería: {{ pedido.transportista.datos.tipo_carroceria }}</p>
                </v-flex>
                <v-flex v-else xs10 sm3 offset-xs2>
                    <h3>No hay transportista asignado</h3>
                </v-flex>
            </v-layout>
        </div>
        <!-- <div v-else-if="searchFailed && !pedido.existe">
            <v-layout row wrap>
                <v-flex xs10 sm6 offset-xs3>
                    <h3>No existe el numero de servicio</h3>
                </v-flex>
            </v-layout>
        </div> -->
        
        <v-snackbar
			v-model="searchMessage.show"
			:color="searchMessage.type"
			right
			:timeout="4000"
			top>
			{{ searchMessage.text }}
			<v-btn
				color="white"
				flat
				@click="searchMessage.show = false">
				Ok
			</v-btn>
		</v-snackbar>
    </v-container>
</template>
<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import * as moment from 'moment'

export default {
    name: 'Seguimiento',
    filters: {
        dateFromTimestamp: function(timestamp) {
            let formattedDate = ''
            if (timestamp.seconds) {
                formattedDate = timestamp.toDate().toLocaleString()
            } else {
                formattedDate = new Date(timestamp).toLocaleString()
            }
            return formattedDate
        }
    },
    data() {
        return {
            markerOptions: {
                url: require('../../assets/static/img/van.png'),
                size: { width: 45, height: 30, f: 'px', b: 'px' },
                scaledSize: { width: 45, height: 30, f: 'px', b: 'px' }
            },
            ns: '',
            searchMessage: {
                show: false,
                type: '',
                text: ''
            },
            pedido: {
                existe: false
            },
            pasos: 0,
            searchFailed: false
        }
    },
    methods: {
        eventTracker(tipo) {
            console.log('entra aqui')
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        searchService(tipo) {
            this.eventTracker(tipo)
            if (this.ns !== '') {
                const db = firebase.firestore()
                const here = this
                const newNS = here.ns.split('.')
                let nsQuery = {}
                here.pedido = {}
                if (newNS[0] === 'F' || newNS[0] === 'f') {
                    nsQuery = {
                        type: newNS[0],
                        c_day: parseInt(newNS[1]),
                        c_general: parseInt(newNS[2]),
                        date: parseInt(newNS[3])
                    }
                    db.collection('fletes_dev').where('NS', '==', nsQuery).get().then(function(querySnapshot) {
                        if (!querySnapshot.empty) {
                            querySnapshot.forEach(function(doc) {
                                const data = doc.data()
                                if (data) {
                                    here.pedido = data
                                    here.pedido.existe = true
                                    here.searchFailed = false
                                    if (here.pedido.progreso && here.pedido.progreso.length > 0) {
                                        here.pasos = here.pedido.progreso.length
                                    }
                                    console.log(here.pedido)
                                }
                            })
                        } else {
                            here.searchFailed = true
                            here.searchMessage.show = true
                            here.searchMessage.type = 'error'
                            here.searchMessage.text = 'No existe el servicio'
                        }
                    })
                    
                } else {
                    nsQuery = {
                        c_day: parseInt(newNS[0]),
                        c_general: parseInt(newNS[1]),
                        date: parseInt(newNS[2])
                    }
                    db.collection('pedidos').where('NS', '==', nsQuery).get().then(function(querySnapshot) {
                        if (!querySnapshot.empty) {
                            querySnapshot.forEach(function(doc) {
                                const data = doc.data()
                                if (data) {
                                    here.pedido = data
                                    here.pedido.existe = true
                                    here.searchFailed = false
                                    if (here.pedido.progreso && here.pedido.progreso.length > 0) {
                                        here.pasos = here.pedido.progreso.length
                                    }
                                    console.log(here.pedido)
                                }
                            })
                        } else {
                            here.searchFailed = true
                            here.searchMessage.show = true
                            here.searchMessage.type = 'error'
                            here.searchMessage.text = 'No existe el servicio'
                        }
                        
                        
                    })
                }
            } else {
                this.searchMessage.show = true
                this.searchMessage.type = 'error'
                this.searchMessage.text = 'Debe ingresar un Número de Servicio'
            }
        }
    },
    mounted() {
            if(this.$route.query.id && this.$route.query.data){
                const data = parseInt(this.$route.query.data)
                const here = this
                const db = firebase.firestore()
                let documento = ''
                if (data === 1) {
                    documento = 'pedidos'
                } else if (data === 2) {
                    documento = 'fletes_dev'
                }
                db.collection(documento).doc(this.$route.query.id).get().then(function(doc) {
                    const data = doc.data()
                    if (data) {
                        here.pedido = data
                        documento === 'pedidos' ? here.ns = here.pedido.NS.c_day + '.' + here.pedido.NS.c_general + '.' + here.pedido.NS.date : here.ns = 'F.' + here.pedido.NS.c_day + '.' + here.pedido.NS.c_general + '.' + here.pedido.NS.date
                        here.pedido.existe = true
                        here.searchFailed = false
                        if (here.pedido.progreso && here.pedido.progreso.length > 0) {
                            here.pasos = here.pedido.progreso.length
                        }
                    } else {
                        here.searchFailed = true
                        here.searchMessage.show = true
                        here.searchMessage.type = 'error'
                        here.searchMessage.text = 'No existe el servicio'
                    }
                })
                .catch(function(error){
                    here.searchFailed = true
                    here.searchMessage.show = true
                    here.searchMessage.type = 'error'
                    here.searchMessage.text = 'No existe el servicio'
                })
            } else {
                console.log('no hay pedido identificado')
            }
      }
}
</script>